import { useCallback, useEffect, useMemo, useState } from "react"
import {Card,Image,Descriptions,Space,Typography,message} from "antd"
import {convertDateToOnlyDate,convertDateToTime} from "../../../utils/TranformDate"
import { useHistory, useLocation, Link } from "react-router-dom"
import { EditOutlined} from '@ant-design/icons';
import InstituteService from "../../../services/InstituteService"
import { ConvertToImage } from "../../../utils/ConvertToFile";
import ModalEditData from "../../Layouts/ModelEditData/ModalEditData";
const {Meta}=Card
const {Item: DItem}=Descriptions
const {Text}=Typography

export default function InstituteData(props) {
    const {Body,updateLogoByInstitute,InstituteLogo,DefaultLogo}=props
    const history = useHistory();
    const { search } = useLocation();
    const [institute,setInstitute]=useState({})
    const [instituteAcademicUnit,setInstituteAcademicUnit]=useState({})
    const [instituteCampus,setInstituteCampus]=useState({})
    const searchParams = useMemo(
        () => new URLSearchParams(search),[search]
    );
    const [logoInstitute,setLogoInstitute]=useState()
    const [showModal,setShowModal]=useState(false)
    const actionInstitute=[
        <Space >
            <Link onClick={()=>(setShowModal(true))} >
                <EditOutlined 
                key="editLogoInstitute" 
                />
                <Text> Actualizar el logo</Text>
            </Link>
        </Space>
    ]

    const hideModal=(option)=>{
        setShowModal(option)
    }

    const updateLogo=(file)=>{
        updateLogoInstitute(institute.id,file)
    }

    const optionsModal={
        open: showModal,
        onCancel:hideModal,
        onUpdateLogo:updateLogo,
    }

    const changeLogoInstitute=()=>{
        if(InstituteLogo?.logoInstitute!=null){
            ConvertToImage(InstituteLogo?.logoInstitute).then(res=>setLogoInstitute(res))       
        }
        else{
            setLogoInstitute(DefaultLogo)
        }
    }

    const updateLogoInstitute=useCallback((InstituteID,fileList)=>{
        console.log("f",fileList.length)
        const formData = new FormData();
        formData.append("logoInstitute","");   
        if(fileList.length>=1)
        {
            let file=fileList[0]
            const blobFile = new Blob([file.originFileObj] , { type: file.type });
            formData.set("logoInstitute",blobFile,file.name);
            // console.log("formData",formData.get("logoCenter"))
            InstituteService.updateLogoByInstitute(formData,InstituteID).then((res)=>{
                // console.log("res",res)
                updateLogoByInstitute(true)
                res.data.success? 
                    message.success("Se actualizo exitosamente el logo del instituto") 
                    :
                    message.error("Ocurrio un problema al actualizar el logo")
            })
        }
        else{
            message.info("No se tiene imagenes para enviar")
        }
        
    })



    useEffect(()=>{
        setInstitute(Body)
        setInstituteCampus(institute.Campus);
        setInstituteAcademicUnit(institute.AcademicUnit);
        changeLogoInstitute()
        if (searchParams.get('option')!=="InstituteData") {
            searchParams.set('option', 'InstituteData');
            history.replace({ search: searchParams.toString() });
        }
    },[{}])

    return(
    <>
        <Card 
        key={"card"+institute?.Id}
        bordered={false}
        style={{backgroundColor:"whitesmoke"}}
        cover={ <Image src={logoInstitute}></Image>}
        actions={actionInstitute }
        >
            <Card>
                <Meta key={"TC"+institute.Id} className="titleCard" title={institute.name}/>
            </Card>
            <Card>
                <Descriptions
                bordered
                >
                    <DItem key={"name"+institute?.Id} label="Nombre" span={3}>{institute?.name}</DItem>
                    <DItem key={"acronym"+institute?.Id} label="Acronimo" span={3}>{institute?.acronym}</DItem>
                    <DItem key={"SA"+institute?.Id} label="Sede academica" span={3}>{instituteCampus?.name}</DItem>
                    <DItem key={"UA"+institute?.Id} label="Unidad academica" span={3}>{instituteAcademicUnit?.name}</DItem>
                    <DItem key={"FC"+institute?.Id} label="Fecha de creacion" span={3}>{convertDateToOnlyDate(institute?.createdAt)}</DItem>
                    <DItem key={"HC"+institute?.Id} label="Hora de creacion" span={3}>{convertDateToTime(institute?.createdAt)}</DItem>
                    <DItem key={"FA"+institute?.Id} label="Fecha de actualización" span={3}>{convertDateToOnlyDate(institute?.updatedAt)}</DItem>
                    <DItem key={"HA"+institute?.Id} label="Hora de actualización" span={3}>{convertDateToTime(institute?.updatedAt)}</DItem>
                </Descriptions>
            </Card>
        </Card>
        <ModalEditData
        data={
            [{
                name: ["logoInstitute"],
                value: logoInstitute,
            }]
        }
        options={optionsModal}
        ></ModalEditData>
        </>
        )
}